import React from "react";
import { StyledFooterWrapper } from "./styled";

const Footer = ({ children, marginLeft, width }: any) => {
  return (
    <StyledFooterWrapper marginleft={marginLeft} width={width}>
      {children}
    </StyledFooterWrapper>
  );
};

export default Footer;
